'use client';

import { useState } from 'react';
import {
  dehydrate,
  HydrationBoundary,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { GlobalStyle } from '@/styles/globalStyle';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from '@/components/errorBoundary';
import { theme } from '@/styles/theme'
import { ModalContextProvider } from './ModalProvider'
import { UserTokenContextProvider } from './UserTokensProvider'

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())
  const dehydratedState = dehydrate(queryClient)

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <HydrationBoundary state={dehydratedState}>
          <ThemeProvider theme={theme}>
            <GlobalStyle />
            <ErrorBoundary>
              <UserTokenContextProvider>
                <ModalContextProvider>{children}</ModalContextProvider>
              </UserTokenContextProvider>
            </ErrorBoundary>
          </ThemeProvider>
        </HydrationBoundary>
      </QueryClientProvider>
    </>
  )
}
